//@ts-nocheck
import React from "react";
import bulbIcon from "../../assets/13b944b8c44d78a19696d4183e2f4b0edab1b89f.png";
import {
  Typography,
  Grid,
  withStyles,
  createStyles,
  List,
  ListItem,
  ListItemText,
  Button,
  RadioGroup,
  Radio,
  Divider,
  CheckboxProps,
  FormControlLabel,
  Checkbox,
  TextField,
  Chip,
} from "@material-ui/core";
import { MAX_ROADMAP_CLIENTS } from "./StartRoadmap/roadmapClients";
import Tooltip from "@material-ui/core/Tooltip";
import { withRouter, RouterProps } from "react-router";
import withAlertBox, { withAlertBoxProps } from "../../../../components/src/withAlertBox.Web";
import withToast, { withToastProps } from "../../../../components/src/withSnackBar.Web";
import withLoader, { withLoaderProps } from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import StorageProvider from "../../../../framework/src/StorageProvider.web";
import InputField from "../../../../components/src/InputFieldPhaseTwo.web";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import CustomTypography from "../../../../components/src/CustomTypography.web";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import { DialogProps } from "../../../../components/src/DialogContext";
import Autocomplete from "@material-ui/lab/Autocomplete";
import _ from "underscore";
import PhoneNumber from "../../../../components/src/PhoneNumber.web";

export type Props = RouterProps &
  DialogProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;
    // Customizable Area Start
    // Customizable Area End
  };

const clientInformationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^[A-Za-z\s-]+$/, "Only alphabets are allowed for this field")
    .required("This field is required."),
  lastName: Yup.string()
    .matches(/^[A-Za-z\s-]+$/, "Only alphabets are allowed for this field")
    .required("This field is required."),
  firmName: Yup.string(),
  spouseFirstName: Yup.string(),
  spouseLastName: Yup.string(),
  primaryEmail: Yup.string()
    .email("Email must be in valid format!")
    .required("This field is required."),
  secondaryEmail: Yup.string().when("primaryEmail", (primaryEmail) => {
    if (primaryEmail) {
      return Yup.string()
        .email("Email must be in valid format!")
        .notOneOf([Yup.ref("primaryEmail"), null], "Secondary email can't be same as primary email.");
    }
  }),
  primaryPhone: Yup.string()
    .nullable(),
  secondaryPhone: Yup.string().when("primaryPhone", (primaryPhone) => {
    if (primaryPhone) {
      return Yup.string()
        .notOneOf([Yup.ref("primaryPhone"), null], "Secondary phone can't be same as primary phone.")
    }
  }),
  notes: Yup.string(),
  input1: Yup.string(),
  primaryCountryCode: Yup.string(),
  secondaryCountryCode: Yup.string(),
  input2: Yup.string(),
  input3: Yup.string(),
  input5: Yup.string(),
  firstPriority: Yup.string(),
  secondPriority: Yup.string(),
  thirdPriority: Yup.string(),
  selectedClient: Yup.object({
    full_name: Yup.string().matches(/^[A-Za-z\s-]+$/, "Only alphabets are allowed for this field"),
  }),
});

const BootstrapTooltip = withStyles((theme: Theme) =>
  createStyles({
    arrow: {
      color: "#fff",
    },
    tooltip: {
      boxShadow: "rgba(0, 0, 0, 0.15) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px",
      padding: "24px",
      fontFamily: "Lato",
      fontSize: "1.2rem",
      backgroundColor: "#FEFEFE",
      borderRadius: "12px",
    },
  })
)(Tooltip);

const QuizDialog = ({ classes }) => {
  return (
    <Grid container justifyContent="space-between" className={classes.dialogBox}>
      <Grid xs={8}>
        <Typography className={classes.tooltipHeading}>Need help selecting a package for this client?</Typography>
      </Grid>
      <Grid item container justifyContent="center" alignItems="center" xs={4}>
        <img className={classes.bulbIcon} src={bulbIcon} />
      </Grid>
    </Grid>
  );
};

const GreenCheckbox = withStyles({
  root: {
    marginLeft: "10px",
    color: "#89c0c1",
    "&$checked": {
      color: "#89c0c1",
    },
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const StyledListItemText = withStyles((theme: Theme) =>
  createStyles({
    primary: {
      fontFamily: "Lato",
      fontSize: "1.75rem",
      color: "#54A4A6",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      marginBottom: theme.spacing(2),
    },
    secondary: {
      fontFamily: "Lato",
      fontSize: "1rem",
      color: "#747474",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
    },
  })
)(ListItemText);

export class ClientInfo extends React.Component {
  formikRef: any = React.createRef();
  autoSubmitInterval: any = null;

  constructor(props: Props) {
    super(props);

    this.searchClientDebounced = _.debounce(this.props.searchClient, 1200);
  }

  async componentDidMount() {
    const token = await StorageProvider.get("authToken");
    if (token) {
      this.props.getRoadMap(this.props?.roadMap?.id);
    }
     this.autoSubmitInterval = setInterval(() => {
    if (!this.formikRef.current) return;

    const {
      values,
      submitForm,
      isValid,
    } = this.formikRef.current;

    const isBasicInfoFilled =
      values.firstName?.trim() &&
      values.lastName?.trim() &&
      values.primaryEmail?.trim();

    if (isBasicInfoFilled && isValid) {
      localStorage.setItem('isAutoSave','true')
      submitForm();
    }
  }, 20000);
  }
  componentWillUnmount() {
    if (this.autoSubmitInterval) {
      clearInterval(this.autoSubmitInterval);
    }
  }

  autoCompleteOnChange = (setFieldValue, event, newValue) => {
    setFieldValue("selectedClient", newValue);
    setFieldValue("firstName", newValue.first_name || "");
    setFieldValue("lastName", newValue.last_name || "");
    setFieldValue("firmName", newValue.firm_name || "");
    setFieldValue("primaryEmail", newValue.primary_email || "");
    setFieldValue("secondaryEmail", newValue.secondary_email || "");
    setFieldValue("primaryPhone", newValue.primary_phone || "");
    setFieldValue("secondaryPhone", newValue.secondary_phone || "");
    setFieldValue("spouseFirstName", newValue.spouse_first_name || "");
    setFieldValue("spouseLastName", newValue.spouse_last_name || "");
  };

  getAutoCompleteOptions = () => {
    const autoCompleteOptions = [];

    for (const item of this.props.searchedClientsList) {
      const full_name = `${item.first_name} ${item.last_name}`;
      const modifiedItem = { ...item, full_name };
      autoCompleteOptions.push(modifiedItem);
    }
    return autoCompleteOptions;
  };

  handleAutoCompleteInputChange = (fieldName, setFieldValue, event, newInputValue) => {
    setFieldValue(fieldName, newInputValue);
    const searchParams = {
      firstName: fieldName === "firstName" ? newInputValue : "",
      lastName: fieldName === "lastName" ? newInputValue : "",
      firmName: fieldName === "firmName" ? newInputValue : "",
    };
    this.searchClientDebounced(searchParams);
  };

  renderAutoCompleteOption = (option: any) => {
    return <div>{option.full_name}</div>;
  };

  handleBlur = (fieldName, setFieldTouched) => {
    setFieldTouched(fieldName, true);
  }

  getValidationSchema = () => {
    const otherClientEmails = (this.props.roadmapClients || [])
      .filter((_client, slot) => slot !== this.props.selectedClientSlot)
      .map((client) => (client.attributes?.primary_email || "").toLowerCase())
      .filter(Boolean);

    return clientInformationSchema.shape({
      primaryEmail: Yup.string()
        .email("Email must be in valid format!")
        .required("This field is required.")
        .test(
          "unique-on-roadmap",
          "This email is already used by another client on this roadmap.",
          (value) => !otherClientEmails.includes((value || "").toLowerCase())
        ),
    });
  };

  handleClientSlotClick = (slot: number) => {
    if (slot === this.props.selectedClientSlot) return;

    const form = this.formikRef.current;
    if (form?.dirty) {
      if (!form.isValid) {
        this.props.showToast({
          type: "error",
          message: "Complete this client's required fields before switching clients.",
        });
        return;
      }
      this.props.saveAndSelectClientSlot(form.values, slot);
      return;
    }
    this.props.selectClientSlot(slot);
  };

  getClientSlotLabel = (client, slot: number, isNextEmptySlot: boolean) => {
    if (client) {
      return `Client ${slot + 1}: ${client.attributes?.first_name || ""} ${client.attributes?.last_name || ""}`.trim();
    }
    return `${isNextEmptySlot ? "+ " : ""}Client ${slot + 1}`;
  };

  renderClientSlots = (classes) => {
    const clients = this.props.roadmapClients || [];
    const slots = Array.from({ length: MAX_ROADMAP_CLIENTS }, (_value, slot) => slot);

    return (
      <Grid item xs={12} md={12}>
        <ListItem>
          <StyledListItemText
            primary="Select clients"
            secondary="You can add up to 5 clients to this roadmap. Select clients in order."
            classes={{
              secondary: classes.secondaryBlueText,
            }}
          />
        </ListItem>
        <Grid container spacing={1} className={classes.bottomMargin}>
          {slots.map((slot) => {
            const client = clients[slot];
            const isNextEmptySlot = slot === clients.length;
            const isSelected = slot === (this.props.selectedClientSlot || 0);

            return (
              <Grid item key={slot}>
                <Chip
                  label={this.getClientSlotLabel(client, slot, isNextEmptySlot)}
                  color={isSelected ? "primary" : "default"}
                  variant={isSelected ? "default" : "outlined"}
                  disabled={!client && !isNextEmptySlot}
                  onClick={() => this.handleClientSlotClick(slot)}
                  onDelete={client && clients.length > 1 ? () => this.props.removeClientSlot(slot) : undefined}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    );
  };

  render() {
    const { classes, theme } = this.props;

    return (
      <Formik
      innerRef={this.formikRef}
        initialValues={{
          firstName: this.props.clientInformation?.attributes?.first_name || "",
          lastName: this.props.clientInformation?.attributes?.last_name || "",
          firmName: this.props.clientInformation?.attributes?.firm_name || "",
          spouseFirstName: this.props.clientInformation?.attributes?.spouse_first_name || "",
          spouseLastName: this.props.clientInformation?.attributes?.spouse_last_name || "",
          primaryEmail: this.props.clientInformation?.attributes?.primary_email || "",
          secondaryEmail: this.props.clientInformation?.attributes?.secondary_email || "",
          primaryPhone: this.props.clientInformation?.attributes?.primary_phone || "",
          secondaryPhone: this.props.clientInformation?.attributes?.secondary_phone || "",
          primaryCountryCode: this.props.clientInformation?.attributes?.primary_country_code || "+1",
          secondaryCountryCode: this.props.clientInformation?.attributes?.secondary_country_code || "+1",
          notes: this.props.clientInformation?.attributes?.notes || "",
          input1: this.props.clientInformation?.attributes?.client_discovery?.inputField1 || "",
          input2: this.props.clientInformation?.attributes?.client_discovery?.inputField2,
          input3: this.props.clientInformation?.attributes?.client_discovery?.inputField3,
          input5: this.props.clientInformation?.attributes?.client_discovery?.inputField5,
          firstPriority: this.props.clientInformation?.attributes?.client_discovery?.inputField4?.firstPriority,
          secondPriority: this.props.clientInformation?.attributes?.client_discovery?.inputField4?.secondPriority,
          thirdPriority: this.props.clientInformation?.attributes?.client_discovery?.inputField4?.thirdPriority,
          selectedClient: {
            first_name: this.props.clientInformation?.attributes?.first_name || "",
            last_name: this.props.clientInformation?.attributes?.last_name || "",
            firm_name: this.props.clientInformation?.attributes?.firm_name || "",
            full_name: "",
          },
        }}
        enableReinitialize
        validationSchema={this.getValidationSchema()}
        onSubmit={this.props.createAndUpdateClientInformation}
      >
        {(formikProps) => {
          const { values, handleChange, setFieldValue, isValid, errors, touched, setFieldTouched } = formikProps;

          return (
            <Form autoComplete="off" noValidate>
              <Grid container direction="row">
                {this.renderClientSlots(classes)}
                <Grid item xs={12} md={12}>
                  <ListItem>
                    <StyledListItemText
                      primary={`Client ${(this.props.selectedClientSlot || 0) + 1} Information`}
                      secondary="Add the client details for this Roadmap Proposal"
                      classes={{
                        secondary: classes.secondaryBlueText,
                      }}
                    />
                  </ListItem>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Grid container justifyContent="space-between">
                    <Grid item md={5} className={classes.bottomMargin} xs={12}>
                      <Autocomplete
                        freeSolo
                        disableClearable
                        noOptionsText="No Client Available"
                        name="firstName"
                        value={values.selectedClient}
                        onChange={this.autoCompleteOnChange.bind(this, setFieldValue)}
                        inputValue={values.firstName}
                        onInputChange={this.handleAutoCompleteInputChange.bind(this, "firstName", setFieldValue)}
                        options={this.getAutoCompleteOptions()}
                        getOptionLabel={(option) => {
                          return option.first_name || "";
                        }}
                        renderOption={this.renderAutoCompleteOption}
                        renderInput={(params) => {
                          return (
                            <TextField
                              {...params}
                              label="First Name"
                              variant="outlined"
                              required
                              error={errors.firstName && touched.firstName}
                              helperText={errors.firstName && touched.firstName ? errors.firstName : ""}
                              onBlur={this.handleBlur.bind(this, "firstName", setFieldTouched)}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid item md={5} className={classes.bottomMargin} xs={12}>
                      <Autocomplete
                        freeSolo
                        disableClearable
                        noOptionsText="No Client Available"
                        name="lastName"
                        value={values.selectedClient}
                        onChange={this.autoCompleteOnChange.bind(this, setFieldValue)}
                        inputValue={values.lastName}
                        onInputChange={this.handleAutoCompleteInputChange.bind(this, "lastName", setFieldValue)}
                        options={this.getAutoCompleteOptions()}
                        getOptionLabel={(option) => {
                          return option.last_name || "";
                        }}
                        renderOption={this.renderAutoCompleteOption}
                        renderInput={(params) => {
                          return (
                            <TextField
                              {...params}
                              label="Last Name"
                              variant="outlined"
                              required
                              error={errors.lastName && touched.lastName}
                              helperText={errors.lastName && touched.lastName ? errors.lastName : ""}
                              onBlur={this.handleBlur.bind(this, "lastName", setFieldTouched)}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid item md={5} className={classes.bottomMargin} xs={12}>
                      <Autocomplete
                        freeSolo
                        disableClearable
                        noOptionsText="No Business Available"
                        name="firmName"
                        value={values.selectedClient}
                        onChange={this.autoCompleteOnChange.bind(this, setFieldValue)}
                        inputValue={values.firmName}
                        onInputChange={this.handleAutoCompleteInputChange.bind(this, "firmName", setFieldValue)}
                        options={this.getAutoCompleteOptions()}
                        getOptionLabel={(option) => {
                          return option.firm_name || "";
                        }}
                        renderOption={(option) => <div>{option.firm_name}</div>}
                        renderInput={(params) => {
                          return (
                            <TextField
                              {...params}
                              label="Business Name"
                              variant="outlined"
                              error={errors.firmName && touched.firmName}
                              helperText={errors.firmName && touched.firmName ? errors.firmName : ""}
                              onBlur={this.handleBlur.bind(this, "firmName", setFieldTouched)}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid item md={5} className={classes.bottomMargin} xs={12}>
                      <Field
                        component={InputField}
                        onChange={handleChange}
                        name="spouseFirstName"
                        value={values.spouseFirstName}
                        fullWidth
                        label="Spouse First Name"
                      />
                    </Grid>
                    <Grid item md={5} className={classes.bottomMargin} xs={12}>
                      <Field
                        component={InputField}
                        onChange={handleChange}
                        name="spouseLastName"
                        value={values.spouseLastName}
                        fullWidth
                        label="Spouse Last Name"
                      />
                    </Grid>
                    <Grid item md={5} className={classes.bottomMargin} xs={12}>
                      <Field
                        component={InputField}
                        onChange={handleChange}
                        name="primaryEmail"
                        value={values.primaryEmail}
                        fullWidth
                        label="Primary Email"
                        required
                      />
                    </Grid>
                    <Grid item md={5} className={classes.bottomMargin} xs={12}>
                      <Field
                        component={InputField}
                        onChange={handleChange}
                        name="secondaryEmail"
                        value={values.secondaryEmail}
                        fullWidth
                        label="Secondary Email"
                      />
                    </Grid>
                    <Grid item xs={12} md={5} className={classes.bottomMargin} style={{ marginTop: '1rem' }}>
                      <Field name="primaryPhone"
                        fullWidth
                        label="Primary Phone">
                        {({ field, form }: any) => (
                          <PhoneNumber
                            countryCode={form.values.primaryCountryCode}
                            phoneNumber={form.values.primaryPhone}
                            onChange={(code, number) => {
                              form.setFieldValue("primaryCountryCode", code);
                              form.setFieldValue("primaryPhone", number);
                            }}
                            placeholder="Enter primary phone"
                            label="Primary Phone"
                          />
                        )}
                      </Field>
                    </Grid>
                    <Grid item xs={12} md={5} className={classes.bottomMargin}>
                      <Field name="secondaryPhone"
                        fullWidth
                        label="Secondary Phone">
                        {({ field, form }: any) => (
                          <PhoneNumber
                            countryCode={form.values.secondaryCountryCode}
                            phoneNumber={form.values.secondaryPhone}
                            onChange={(code, number) => {
                              form.setFieldValue("secondaryCountryCode", code);
                              form.setFieldValue("secondaryPhone", number);
                            }}
                            placeholder="Enter secondary phone"
                            label="Secondary Phone"
                          />
                        )}
                      </Field>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Field
                        component={InputField}
                        onChange={handleChange}
                        name="notes"
                        placeholder="Industry, Gross Revenue/Income, Entity Structure, # of Employees, Accounting/Payroll software, Legacy goals for the business, etc."
                        multiline
                        minRows={3}
                        value={values.notes}
                        fullWidth
                        label="Notes"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{
                    margin: "1rem 0",
                  }}
                >
                  <Divider light />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Grid container justifyContent="space-between" spacing={4}>
                    <Grid item xs={12}>
                      <ListItem>
                        <StyledListItemText
                          primary="Client Discovery"
                          secondary="Use these questions as the basis for your Discovery Meeting with the client at the end"
                          classes={{
                            secondary: classes.secondaryBlueText,
                          }}
                        />
                      </ListItem>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.qLabel}>
                        1. No matter what happens over the next 12 months, what progress do you want to accomplish in the next year?
                      </Typography>
                      <Field
                        component={InputField}
                        onChange={handleChange}
                        name="input1"
                        value={values.input1}
                        fullWidth
                        classes={classes.spaceBetween}
                        label=""
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.qLabel}>
                        2. How will accomplishing this make your life and/or business better? What will the tangible impact be?
                      </Typography>
                      <Field component={InputField} onChange={handleChange} name="input2" value={values.input2} fullWidth label="" />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.qLabel}>
                        3. Other clients who also wrestled with [give examples]. Has that been an issue for you? Or would you like to solve this as well?
                      </Typography>
                      <Field component={InputField} onChange={handleChange} name="input3" value={values.input3} fullWidth label="" />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.qLabel}>
                        4. All of these items are important and interrelated, what are your top three priorities:
                      </Typography>
                      <Grid container spacing={2} alignItems="center" justifyContent="space-around">
                        <Grid item xs={2} container alignItems="center" className={classes.subPoint}>
                          <CustomTypography className={classes.prioritiesLabel}>1st Priority?</CustomTypography>
                        </Grid>
                        <Grid item xs={10} className={classes.subField}>
                          <Field component={InputField} onChange={handleChange} name="firstPriority" value={values.firstPriority} fullWidth />
                        </Grid>
                        <Grid item xs={2} className={classes.subPoint}>
                          <Typography className={classes.prioritiesLabel}>2nd Priority?</Typography>
                        </Grid>
                        <Grid item xs={10} className={classes.subField}>
                          <Field component={InputField} onChange={handleChange} name="secondPriority" value={values.secondPriority} fullWidth />
                        </Grid>
                        <Grid item xs={2} className={classes.subPoint}>
                          <Typography className={classes.prioritiesLabel}>3rd Priority?</Typography>
                        </Grid>
                        <Grid item xs={10} className={classes.subField}>
                          <Field component={InputField} onChange={handleChange} name="thirdPriority" value={values.thirdPriority} fullWidth />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.qLabel}>5. Is there anythine else we haven't addressed that's on your mind?</Typography>
                      <Field component={InputField} onChange={handleChange} name="input5" value={values.input5} fullWidth label="" />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.qLabel} />
                      <Typography className={classes.qLabel}>6. Do you feel the client is aligned? (Product, Price, Personality and Skillset)</Typography>
                      <RadioGroup
                        className={classes.radioGroup}
                        row
                        name="isClientAligned"
                        value={this.props.isClientAligned}
                        onChange={(e) =>
                          this.props.setState({
                            [e.target.name]: e.target.value,
                          })
                        }
                      >
                        <FormControlLabel
                          className={classes.yesRadio}
                          value="Yes"
                          control={
                            <Radio
                              color="primary"
                              icon={<CheckBoxOutlineBlankIcon />}
                              checkedIcon={<CheckBoxIcon />}
                              style={{
                                color: theme.palette.primary.main,
                              }}
                            />
                          }
                          label="Yes"
                          classes={{
                            label: classes.radioLabel,
                          }}
                        />
                        <FormControlLabel
                          className={classes.noRadio}
                          value="No"
                          control={
                            <Radio
                              icon={<CheckBoxOutlineBlankIcon />}
                              checkedIcon={<CheckBoxIcon />}
                              style={{
                                color: theme.palette.error.main,
                              }}
                            />
                          }
                          label="No"
                          classes={{
                            label: classes.radioLabel,
                          }}
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.qLabel}>7. Thank you for meeting today, here are the next steps:</Typography>
                      <List dense={true}>
                        <ListItem style={{ position: "relative" }}>
                          <ListItemText
                            primary="We'll put together a roadmap document that details how we can best help with the results we discussed today including pricing."
                            classes={{
                              primary: classes.listItemPrimary,
                            }}
                          />
                        </ListItem>
                        <ListItem style={{ position: "relative" }}>
                          <ListItemText
                            classes={{
                              primary: classes.listItemPrimary,
                            }}
                            primary="We'll schedule one more quick call together to review the roadmap, answer any questions, and modify the roadmap if necessary."
                          />
                        </ListItem>
                        <ListItem style={{ position: "relative" }}>
                          <ListItemText
                            classes={{
                              primary: classes.listItemPrimary,
                            }}
                            primary="Once everything makes sense and is agreed upon, we can allocate resources for your work and get started."
                          />
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.qLabel} display="inline">
                        8.
                      </Typography>
                      <FormControlLabel
                        control={
                          <GreenCheckbox
                            checked={this.props.scheduleDateTime}
                            onChange={(e) => {
                              this.props.setState({
                                scheduleDateTime: e.target.checked,
                              });
                            }}
                            name="scheduleDateTime"
                            style={{
                              color: theme.palette.primary.main,
                            }}
                          />
                        }
                        label="Schedule date & time for Roadmap Review meeting"
                        classes={{
                          label: classes.checkboxLabel,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12} className={classes.cardPaper}>
                  <Grid container direction="row" justifyContent="flex-end" spacing={2}>
                    <Grid item xs={6} md={2} container justifyContent="flex-end">
                      <BootstrapTooltip title={<QuizDialog classes={classes} />} arrow placement="top-start">
                        <Button
                          color="primary"
                          onClick={() => {
                            this.props.openTakeQuiz(values);
                          }}
                          variant="outlined"
                        >
                          {this.props.getQuizText()}
                        </Button>
                      </BootstrapTooltip>
                    </Grid>
                    <Grid item xs={6} md={2} container justifyContent="flex-end">
                      <Button type="submit" color="primary" variant="contained" disabled={!isValid || this.props.isSavingClientInformation}
                        onClick={()=>localStorage.removeItem('isAutoSave')}>
                        Save & continue
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const ClientInfoWithRouter = withRouter(ClientInfo);
const ClientInfoAlertBox = withAlertBox(ClientInfoWithRouter);
const ClientInfoLoader = withLoader(ClientInfoAlertBox);
const ClientInfoToast = withToast(ClientInfoLoader);
const ClientInfoWithDialog = withDialog(ClientInfoToast);

export default withStyles(
  (theme) =>
    createStyles({
      yesRadio: {
        paddingRight: 10,
        paddingLeft: 10,
        paddingBottom: 10,
        "& .MuiIconButton-label": {
          border: "1px",
          color: "#89c0c1",
        },
      },
      noRadio: {
        paddingRight: 10,
        paddingLeft: 10,
        paddingBottom: 10,
        "& .MuiIconButton-label": {
          color: "#ffa3a3",
        },
      },
      cardPaper: {
        [theme.breakpoints.up("md")]: {
          margin: theme.spacing(2, 1),
        },
        margin: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      spaceBetween: {
        marginTop: "50px",
        "& .InputFieldWithFormik-inputfieledroot-39": {
          marginTop: "50px",
        },
      },
      qLabel: {
        fontSize: "0.95rem",
        marginBottom: "0.625rem",
        color: theme.palette.text.secondary,
      },
      checkboxLabel: {
        fontSize: "0.95rem",
        color: theme.palette.text.secondary,
      },
      prioritiesLabel: {
        fontSize: "1.1rem",
        fontWeight: 700,
        marginBottom: "0.625rem",
        color: "#3a3f63",
      },
      subPoint: {
        width: "15%",
      },
      subField: {
        width: "85%",
      },
      dialogBox: {
        width: "250px",
      },
      tooltipHeading: {
        color: theme.palette.text.blue2,
        fontSize: "1rem",
      },
      bulbIcon: {
        width: "45px",
        height: "50px",
      },
      listItemPrimary: {
        fontSize: "0.95rem",
        fontFamily: "Lato",
        color: theme.palette.text.secondary,
        paddingBottom: "0.625rem",
        paddingLeft: "2rem",
        "&:before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: "25%",
          width: "10px",
          height: "10px",
          display: "block",
          backgroundColor: "#3a3f63",
          borderRadius: "50%",
        },
      },
      secondaryBlueText: {
        color: theme.palette.text.blue2,
        fontWeight: "normal",
      },
      bottomMargin: {
        marginBottom: "1rem",
      },
      radioLabel: {
        color: theme.palette.text.blue2,
        fontWeight: "bold",
      },
    }),
  { withTheme: true }
)(withConfirmBox(ClientInfoWithDialog));
